export interface ICompaniesTableFields {
    _id: string;
    name: string;
    street: string;
    city: string;
    zip: string;
    legalform: string;
}
